export const AllotmentType = {
  freeSell: 0,
  onRequest: 1,
  allotment: 2,
};
